<p-toast />
<div class="spinner-overlay" *ngIf="isLoading">
  <div class="spinner-container">
    <h2 class="spinner-header">Generando el reclamo</h2>
    <app-spinner></app-spinner>
  </div>
</div>

<p-confirmDialog #cd>
  <ng-template pTemplate="headless" let-message class="confirmDialog">
    <div
      class="flex flex-column align-items-center p-5 surface-overlay border-round"
    >
      <span class="labelTitle1">
        {{ message.header }}
      </span>
      <div class="flex justify-content-center align-items-center gap-2">
        <i class="pi pi-exclamation-circle"></i>
        <p class="text-base">{{ message.message }}</p>
      </div>
      <div
        class="flex flex-row justify-content-center align-items-center gap-2 mt-3"
      >
        <ng-container *ngIf="isNewClaim" class="col-12">
          <button
            pButton
            label="Cancelar"
            (click)="cd.reject()"
            class="btn-cancelar col-6"
            style="
              border: 1px solid #263245;
              background-color: white;
              color: #263245;
              font-size: 0.8rem;
            "
          ></button>
          <button
            pButton
            label="¡Entendido!"
            (click)="cd.accept()"
            class="btn-siguiente col-6"
            style="
              background-color: #263245;
              border-color: #263245;
              font-size: 0.8rem;
            "
          ></button>
        </ng-container>
        <ng-container *ngIf="!isNewClaim" class="col-12">
          <button
            pButton
            label="Cancelar"
            (click)="cd.reject()"
            class="btn-cancelar col-6"
            style="
              border: 1px solid #263245;
              background-color: white;
              color: #263245;
              font-size: 0.8rem;
            "
          ></button>
          <button
            pButton
            label="Aceptar"
            (click)="cd.accept()"
            class="btn-siguiente col-6"
            style="
              background-color: #263245;
              border-color: #263245;
              font-size: 0.8rem;
            "
          ></button>
        </ng-container>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<div class="w-full relative p-4">
  <div class="container-top">
    <i routerLink="/main/claims" class="pi pi-angle-left"></i>
    <p><a href="" routerLink="/main/claims">Mis reclamos laborales</a></p>
    <p>/</p>
    <p>
      <a class="font-bold">{{
        isNewClaim ? "Nuevo reclamo laboral" : "Editar reclamo laboral"
      }}</a>
    </p>
  </div>
  <div class="container-title">
    <p *ngIf="isNewClaim" class="title font-bold">Nuevo reclamo laboral</p>
    <p *ngIf="!isNewClaim" class="title font-bold">Editar reclamo laboral</p>
    <p class="description">
      Complete los datos requeridos para
      {{
        isNewClaim ? "realizar el reclamo laboral" : "editar el reclamo laboral"
      }}
    </p>
  </div>

  <div class="w-full">
    <p-tabView [(activeIndex)]="activeIndex" class="w-full disabled-tab">
      <ng-container *ngFor="let step of stepPanels; let i = index">
        <p-tabPanel class="w-full">
          <ng-template pTemplate="header">
            <div class="hidden md:block">{{ step.label }}</div>
            <div class="block md:hidden">
              <i
                class="{{ step.icon }} text-base"
                [pTooltip]="step.label"
                tooltipPosition="right"
              ></i>
            </div>
          </ng-template>
          <ng-container *ngTemplateOutlet="step.contentTemplate"></ng-container>
        </p-tabPanel>
      </ng-container>
    </p-tabView>
    <ng-template #repTemplate>
      <app-personal-details-multi
        class="fadein animation-duration-500"
        [userData]="userData"
        [claim]="claim"
        (activeModal)="cancel($event)"
        (claimantDetailsForm)="receiveData($event)"
        (stepIndex)="activeStep($event)"
      ></app-personal-details-multi>
    </ng-template>

    <ng-template #claimantTemplate>
      <app-claimant-details-multi
        [activeIndex]="activeIndex"
        class="fadein animation-duration-500"
        (activeModal)="cancel($event)"
        (claimantDetailsForm)="receiveData($event)"
        (stepIndex)="activeStep($event)"
        [isEdit]="isEdit"
        [claim]="claim"
        [userData]="userData"
        [isRepresentative]="isRepresentative"
      ></app-claimant-details-multi>
    </ng-template>

    <ng-template #claimedTemplate>
      <app-claimed-details-multi
        class="fadein animation-duration-500"
        [claim]="claim"
        (activeModal)="cancel($event)"
        (claimantDetailsForm)="receiveData($event)"
        (stepIndex)="activeStep($event)"
        [isRepresentative]="isRepresentative"
      ></app-claimed-details-multi>
    </ng-template>

    <ng-template #claimDetailsTemplate>
      <app-claim-details-form
        class="fadein animation-duration-500"
        [claim]="claim"
        (activeModal)="cancel($event)"
        (claimDetailsEdit)="receiveData($event)"
        (stepIndex)="activeStep($event)"
        (claimDetails)="formComplete($event)"
        [isRepresentative]="isRepresentative"
      ></app-claim-details-form>
    </ng-template>
  </div>
</div>

<app-spinner-load [isLoading]="isLoadingEdit"></app-spinner-load>
